import i18n from 'i18next';
import type { DriveStep, Popover } from 'driver.js';

/**
 * Tour step copy is written as translation keys (`'tutorials.searchSessions'`)
 * rather than English, because most step arrays are module-level constants and
 * the UI language can change while the app runs. The keys are resolved here, at
 * the point a tour is built (the user opening it), never at import time.
 *
 * Only strings that look like one of our keys are translated: steps whose copy
 * is assembled at build time (see pageSteps.ts) already hold translated text and
 * pass through unchanged.
 */
const KEY_PREFIXES = ['tutorials.', 'common.'];

const TEXT_FIELDS = ['title', 'description', 'doneBtnText', 'nextBtnText', 'prevBtnText'] as const;

function translate(value: string): string {
  return KEY_PREFIXES.some((prefix) => value.startsWith(prefix)) ? i18n.t(value) : value;
}

export function localizeSteps(steps: DriveStep[]): DriveStep[] {
  return steps.map((step) => {
    if (!step.popover) return step;
    const popover: Popover = { ...step.popover };
    TEXT_FIELDS.forEach((field) => {
      const value = popover[field];
      if (typeof value === 'string') popover[field] = translate(value);
    });
    return { ...step, popover };
  });
}
